export enum ContainerType {
  FULL_WIDTH,
}
